import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38a5bca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "community-wrapper" }
const _hoisted_2 = { class: "community-tip" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi info-icon" }, null, -1))
const _hoisted_4 = { class: "category-checkbox" }
const _hoisted_5 = {
  key: 1,
  class: "btn-con"
}

import {reactive, ref, watch, onMounted, computed} from 'vue';
import ComponentFormItem from './ComponentFormItem.vue';
import Message from '@/components/message/message.js';
type ICategoryList = {
    firstCategoryCode: string;
    chooseCategoryOptionList: [];
    // delayOpenTimeDuration?: string;
    visibleTime: number;
}[];


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishDialog',
  props: {
    id: { default: undefined },
    tenant: { default: '' },
    brand: { default: '' },
    scope: { default: 'community_open' },
    visible: { type: Boolean, default: false },
    isOverflow: { type: Boolean, default: true },
    showConfirmButton: { type: Boolean, default: true }
  },
  emits: ['success', 'cancel'],
  setup(__props: any, { expose, emit }) {

const props = __props as { id: number | string, tenant: string, brand: string, scope: string, visible: boolean, isOverflow: boolean, showConfirmButton: boolean };


expose<{
    getParams:() => Promise<{
        chooseCategoryList: ICategoryList;
        // delayOpenTimeDuration: string | number;
        // delayOpenTimeUnit: string;
        visibleTime: number;
    }>;
}>({getParams});


const loading = ref(false);
const categoryFormRef = ref([]);
const formRef = ref();
const formData = ref<{categoryId: string[]}>({categoryId: []});
const communityConfigData = ref<any[]>([]);

onMounted(() => {
    console.log('push dialog form mounted');
    getCommunityAssetCategory();
});

async function getParams() {
    // 外侧选择的是私有时。直接返回默认值不验证
    if (!formRef.value) {
        return {
            chooseCategoryList: [],
            // delayOpenTimeDuration: 6,
            // delayOpenTimeUnit: 'Months',
            visibleTime: new Date().getTime()
        };
    }
    // 公有则遍历获取表单内容
    await formRef.value.validate();
    const res: ICategoryList = await Promise.all(
        // @ts-ignore
        categoryFormRef.value.map(item => item.getFormData())
    );
    const stsjItem = res.find(item => item.firstCategoryCode === 'zyzx_stsj');
    let params = {
        chooseCategoryList: res,
        // delayOpenTimeDuration: stsjItem?.delayOpenTimeDuration || 6,
        // delayOpenTimeUnit: 'Months',
        visibleTime: new Date().getTime()
    };
    // stsjItem && delete stsjItem.delayOpenTimeDuration;
    return params;
}

const handleConfirm = async () => {
    try {
        loading.value = true;
        const communityOpenInfo = await getParams();
        let params = {
            idList: [props.id],
            communityOpen: true,
            communityOpenInfo
        };
        console.log('params', params);
        await G_transmit('resourcePublish', {
            name: 'resourcePublish',
            data: params
        });
        Message({type: 'success', text: '您的资源已成功提交审核'});
        emit('success');
        handleCancel();
    } catch (error: any) {
        console.log('error', error);
        Message({
            type: 'info',
            text: error.message || error.status?.desc || '请将必填项填写完整'
        });
    }
    loading.value = false;
};

const handleCancel = () => {
    formRef.value.resetFields();
    emit('cancel');
};

// 获取默认列表
const getCommunityAssetCategory = async () => {
    try {
        const res = await G_transmit('getFilterCommunityAssetCategory', {
            queries: {
                tenant: props.tenant,
                brand: props.brand
            }
        });
        communityConfigData.value = res.data || [];
    } catch (error: any) {
        Message({type: 'info', text: error.message});
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(props.scope === 'community_open'
                        ? '该资源将公开到目标网站，所有人可见'
                        : '该资源将存放在目标网站个人资源中，仅自己可见'), 1)
    ]),
    (props.scope === 'community_open')
      ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          "label-width": "80px",
          class: "community-form",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form_item, {
                label: "资源类型：",
                prop: "categoryId",
                class: "entire-line-item form-item-nomarginbottom",
                "label-width": "94px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: formData.value.categoryId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.categoryId) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communityConfigData.value, (i) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: i.categoryCode,
                          label: i.categoryCode,
                          class: "srt-el-checkbox"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(i.categoryName), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(['model-form-con', {'overflow-model-form': __props.isOverflow}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communityConfigData.value, (i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: i.categoryCode
                }, [
                  (formData.value.categoryId.includes(i.categoryCode))
                    ? (_openBlock(), _createBlock(ComponentFormItem, {
                        key: 0,
                        ref_for: true,
                        ref_key: "categoryFormRef",
                        ref: categoryFormRef,
                        categoryName: i.categoryName,
                        categoryCode: i.categoryCode,
                        options: i.subCategoryList,
                        brand: props.brand,
                        tenant: props.tenant
                      }, null, 8, ["categoryName", "categoryCode", "options", "brand", "tenant"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, loading.value]
        ])
      : _createCommentVNode("", true),
    (__props.showConfirmButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            class: "srt-el-button srt-el-button--cancel srt-el-button-h36",
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "srt-el-button srt-el-button--primary srt-el-button-h36",
            disabled: formData.value.categoryId.length === 0,
            onClick: handleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})